/**
 * @generated SignedSource<<295ac6bf8a4e9cf1586f5e7f289d69ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddOrRemoveAssignmentPrintTypeToProductsInput = {
  modelSidesToAssignsDto?: ReadonlyArray<AddOrRemoveAssignmentPrintTypeToProductsModelSidesToAssignInput | null> | null;
  printTypeID: string;
  productIDsToRemove?: ReadonlyArray<string | null> | null;
};
export type AddOrRemoveAssignmentPrintTypeToProductsModelSidesToAssignInput = {
  modelID: string;
  sides: ReadonlyArray<PrintTypeModelSideInput | null>;
};
export type PrintTypeModelSideInput = {
  colorID: string;
  sideID: string;
};
export type addPrintingMethodPanel_AssignMutation$variables = {
  input: AddOrRemoveAssignmentPrintTypeToProductsInput;
};
export type addPrintingMethodPanel_AssignMutation$data = {
  readonly addOrRemoveAssignmentPrintTypeToProducts: boolean;
};
export type addPrintingMethodPanel_AssignMutation = {
  response: addPrintingMethodPanel_AssignMutation$data;
  variables: addPrintingMethodPanel_AssignMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "addOrRemoveAssignmentPrintTypeToProducts",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addPrintingMethodPanel_AssignMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addPrintingMethodPanel_AssignMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1d087077a97eb2db763e1291d14bd2f2",
    "id": null,
    "metadata": {},
    "name": "addPrintingMethodPanel_AssignMutation",
    "operationKind": "mutation",
    "text": "mutation addPrintingMethodPanel_AssignMutation(\n  $input: AddOrRemoveAssignmentPrintTypeToProductsInput!\n) {\n  addOrRemoveAssignmentPrintTypeToProducts(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "8ddd733c5d8427e1e9d92592750f90b5";

export default node;
